import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=60f1ebd8&scoped=true&"
import script from "./PublishButton.vue?vue&type=script&lang=js&"
export * from "./PublishButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1ebd8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f1ebd8')) {
      api.createRecord('60f1ebd8', component.options)
    } else {
      api.reload('60f1ebd8', component.options)
    }
    module.hot.accept("./PublishButton.vue?vue&type=template&id=60f1ebd8&scoped=true&", function () {
      api.rerender('60f1ebd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/PublishButton.vue"
export default component.exports